import { render, staticRenderFns } from "./billers-landing.vue?vue&type=template&id=48f240ec&scoped=true"
import script from "./billers-landing.vue?vue&type=script&lang=js"
export * from "./billers-landing.vue?vue&type=script&lang=js"
import style0 from "./billers-landing.vue?vue&type=style&index=0&id=48f240ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f240ec",
  null
  
)

export default component.exports